<template>
  <v-content style="height: 100%">
    <Header :title="section"></Header>

    <v-layout justify-center mt-5>
      <v-flex pa-4>
        <v-layout :class="section !== 'title' ? 'justify-space-between' : 'justify-end'" mb-7>
          <v-flex v-if="section === 'title'" shrink>
            <v-layout>
              <v-flex cea-color mr-4 pt-3> ค้นหารายการ :</v-flex>
              <v-flex mr-4>
                <v-text-field v-model="keywordTopic" flat solo @keyup.enter="searchTopic"></v-text-field>
              </v-flex>
              <v-flex mr-4>
                <v-btn class="cea-color" color="#FFF" depressed large style="border: solid 1px #ff4f23"
                  @click="searchTopic">
                  <v-icon class="mr-3">search</v-icon>
                  ค้นหา
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex v-else-if="section === 'import'" shrink>
            <v-layout>
              <v-layout mr-7>
                <v-flex mr-4 pt-3> หัวข้อ :</v-flex>
                <v-flex mr-4>
                  <v-text-field v-model="keywordImport" flat solo @keyup.enter="searchImport"></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout>
                <v-flex mr-4 pt-3> ปี :</v-flex>
                <v-flex mr-4>
                  <v-select v-model="yearImport" :items="yearList" flat menu-props="offsetY" solo style="width: 150px"
                    @change="searchImport"></v-select>
                </v-flex>
              </v-layout>
            </v-layout>
          </v-flex>
          <v-flex v-else>
            <!-- leave it blank to align the InputForm -->
          </v-flex>

          <v-flex shrink>

            <InputForm :type="section"></InputForm>

          </v-flex>
        </v-layout>

        <!--        <div-->
        <!--          v-if="section !== 'footer' && section !== 'banner'"-->
        <!--          class="mb-7 cea-underline"-->
        <!--        ></div>-->

        <!-- Loading overlay -->
        <loading :active.sync="sectionLoaded" :is-full-page="false" loader="bars"></loading>

        <v-layout v-if="section === 'title'" justify-center>
          <v-flex>
            <v-simple-table style="border: solid 1px #ff4f23">
              <thead class="white--text" style="background-color: #4f4f4f">
                <tr>
                  <td width="10%">ลำดับ</td>
                  <td width="80%">หัวข้อ</td>
                  <td width="10%">แก้ไข</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, i) in topicList.data" :key="i">
                  <td>{{ item.id }}.</td>
                  <td class="text-start">{{ item.name_th }}</td>
                  <td>
                    <InputForm :edit="true" :param="item.id" :type="section"></InputForm>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>

            <v-layout justify-end mt-3>
              <v-flex v-if="paginationTopic.total > 0" shrink>
                <v-pagination v-if="topicLoaded" v-model="paginationTopic.current" :length="paginationTopic.total"
                  :total-visible="pageVisible" circle color="#FF4F23" @input="onTopicPageChange"></v-pagination>
              </v-flex>
              <v-flex v-else mr-3 shrink> ไม่พบรายการข้อมูล</v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-layout v-else-if="section === 'import'" justify-center>
          <v-flex>
            <v-simple-table style="border: solid 1px #ff4f23">
              <thead class="white--text" style="background-color: #4f4f4f">
                <tr>
                  <td width="5%">ลำดับ</td>
                  <td width="10%">ชื่อ</td>
                  <td width="10%">หัวข้อ</td>
                  <td width="40%">ตัวชี้วัด</td>
                  <td width="5%">ปี</td>
                  <td width="10%">วัน/เวลา<br />นำเข้า</td>
                  <td width="5%">สถานะ<br />การแสดง</td>
                  <td width="5%">ดูข้อมูล</td>
                  <td width="10%">ผู้นำเข้า<br />ข้อมูล</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, i) in importedList.data" :key="i">
                  <td>{{ item.id }}.</td>
                  <td class="text-start">{{ item.name }}</td>
                  <td class="text-start">{{ item.name_topic.name_th }}</td>
                  <td class="text-start">
                    {{ item.index.index_code + " - " + item.index.name_th }}
                  </td>
                  <td>{{ item.year_data }}</td>
                  <td>{{ item.created_at | moment("DD/MM/YYYY HH:MM:SS") }}</td>
                  <td>
                    <v-icon :class="{ 'cea-color': item.display_status === 1 }">{{
                      item.display_status === 0 ? "close" : "check"
                    }}
                    </v-icon>
                  </td>
                  <td>
                    <v-icon color="#FF4F23" @click="openFile(item.file_path)">search
                    </v-icon>
                  </td>
                  <td>{{ item.user.first_name }}</td>
                </tr>
              </tbody>
            </v-simple-table>

            <v-layout justify-end mt-3>
              <v-flex v-if="paginationImported.total > 0" shrink>
                <v-pagination v-if="importedLoaded" v-model="paginationImported.current"
                  :length="paginationImported.total" :total-visible="pageVisible" circle color="#FF4F23"
                  @input="onImportedPageChange"></v-pagination>
              </v-flex>
              <v-flex v-else mr-3 shrink> ไม่พบรายการข้อมูล</v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-layout v-else-if="section === 'unit'" justify-center>
          <v-flex>
            <v-simple-table style="border: solid 1px #ff4f23">
              <thead class="white--text" style="background-color: #4f4f4f">
                <tr>
                  <td width="10%">ลำดับ</td>
                  <td width="80%">หน่วย</td>
                  <td width="10%">แก้ไข</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, i) in unitList.data" :key="i">
                  <td>{{ item.unit_id }}.</td>
                  <td class="text-start">{{ item.name_th }}</td>
                  <td>
                    <InputForm :edit="true" :param="item.unit_id" :type="section"></InputForm>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>

            <v-layout justify-end mt-3>
              <v-flex v-if="paginationUnit.total > 0" shrink>
                <v-pagination v-if="unitLoaded" v-model="paginationUnit.current" :length="paginationUnit.total"
                  :total-visible="pageVisible" circle color="#FF4F23" @input="onUnitPageChange"></v-pagination>
              </v-flex>
              <v-flex v-else mr-3 shrink> ไม่พบรายการข้อมูล</v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-layout v-else-if="section === 'tag'" justify-center>
          <v-flex>
            <v-simple-table style="border: solid 1px #ff4f23">
              <thead class="white--text" style="background-color: #4f4f4f">
                <tr>
                  <td width="10%">ลำดับ</td>
                  <td width="80%">#Tag</td>
                  <td width="10%">แก้ไข</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, i) in tagList.data" :key="i">
                  <td>{{ item.id }}.</td>
                  <td class="text-start">{{ item.name }}</td>
                  <td>
                    <InputForm :edit="true" :param="item.id" :type="section"></InputForm>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>

            <v-layout justify-end mt-3>
              <v-flex v-if="paginationTag.total > 0" shrink>
                <v-pagination v-if="tagLoaded" v-model="paginationTag.current" :length="paginationTag.total"
                  :total-visible="pageVisible" circle color="#FF4F23" @input="onTagPageChange"></v-pagination>
              </v-flex>
              <v-flex v-else mr-3 shrink> ไม่พบรายการข้อมูล</v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-layout v-else-if="section === 'main-menu'" justify-center>
          <v-flex>
            <v-simple-table style="border: solid 1px #ff4f23">
              <thead class="white--text" style="background-color: #4f4f4f">
                <tr>
                  <td width="5%">ลำดับ</td>
                  <td width="54%">ชื่อไทย</td>
                  <td width="54%">ชื่ออังกฤษ</td>
                  <td width="54%">สถานะ</td>
                  <td width="5%">แก้ไข</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, i) in mainMenuList.data" :key="i">
                  <td class="text-center">{{ item.id }}.</td>
                  <td class="text-start">{{ item.name_th }}</td>
                  <td class="text-start">{{ item.name_en }}</td>
                  <td class="text-start">{{ item.status === 1 ? 'ใช้งาน' : 'ไม่ใช้งาน' }}</td>
                  <td>
                    <InputForm :edit="true" :param="item.id" :type="section"></InputForm>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
            <!-- <v-layout justify-end mt-3>
              <v-flex v-if="paginationMainMenu.total > 0" shrink>
                <v-pagination v-if="mainMenuLoaded" v-model="paginationMainMenu.current" :length="paginationMainMenu.total"
                  :total-visible="pageVisible" circle color="#FF4F23" @input="onMainMenuPageChang"></v-pagination>
              </v-flex>
              <v-flex v-else mr-3 shrink> ไม่พบรายการข้อมูล</v-flex>
            </v-layout> -->
          </v-flex>
        </v-layout>

        <!-- Banner management page -->
        <v-layout v-else-if="section === 'banner'" justify-center>
          <v-flex xs12>
            <v-layout justify-center>
              <v-flex xs10>
                <!--Main page banners (multiple)-->
                <!-- <v-layout column>
                  <v-flex mb-5 text-start>
                    <v-layout cea-color justify-start mb-3 txt-head>
                      Main page banners (multiple)
                    </v-layout>
                    <div class="mb-7 cea-underline"></div>
                    <draggable :disabled="!enabled" :list="overviewBanner" :move="checkMove" class="list-group"
                      ghost-class="ghost" @end="dragging = false" @start="dragging = true">
                      <div v-for="(item, i) in overviewBanner" :key="i" class="mb-7 banner-box">

                        <v-btn v-if="overviewBanner.length > 1 && i !== 0" absolute color="#FF4F23" fab
                          style="right: -12px" top x-small @click="removeBannerIndex(i)">
                          <v-icon color="white">close</v-icon>

                        </v-btn>
                        <div v-if="item.desktop_img">
                          <v-layout cea-color justify-start mb-3 txt-head>
                            Banner {{ i + 1 }}
                          </v-layout>
                          <v-img :src="http + item.desktop_img" class="banner-preview" contain></v-img>
                        </div>
                        <v-layout justify-end>
                          <v-flex mr-3 pt-3 shrink> Desktop size :</v-flex>
                          <v-flex xs7>
                            <v-file-input v-model="item.desktop_file"
                              label="ขนาดของไฟล์ไม่ควรเกิน 1 MB และขนาดรูป คือ 1900 x 792 px" show-size @change="
                                bannerImageAdded(
                                  $event,
                                  'overviewBanner',
                                  'desktop',
                                  i
                                )
                                "></v-file-input>
                          </v-flex>
                        </v-layout>
                        <div v-if="item.mobile_img">
                          <v-img :src="http + item.mobile_img" class="banner-preview" contain></v-img>
                        </div>
                        <v-layout justify-end>
                          <v-flex mr-3 pt-3 shrink> Mobile size :</v-flex>
                          <v-flex xs7>
                            <v-file-input v-model="item.mobile_file"
                              label="ขนาดของไฟล์ไม่ควรเกิน 1 MB และขนาดรูป คือ 566 x 566 px" show-size @change="
                                bannerImageAdded(
                                  $event,
                                  'overviewBanner',
                                  'mobile',
                                  i
                                )
                                "></v-file-input>
                          </v-flex>
                        </v-layout>
                        <v-layout justify-end>
                          <v-flex mr-3 pt-3 shrink> link :</v-flex>
                          <v-flex xs7>
                            <v-text-field v-model="item.url"></v-text-field>
                          </v-flex>
                        </v-layout>
                      </div>
                    </draggable>

                    <div style="display: flex; justify-content: right">
                      <span v-if="overviewBanner.length < 5">
                        <v-btn class="white--text mb-3" color="#FF4F23" @click="addMoreBanner">
                          <v-icon>add</v-icon>
                        </v-btn>
                      </span>

                    </div>
                  </v-flex>
                </v-layout> -->

                <v-layout column>
                  <v-flex mb-5 text-start>
                    <v-layout cea-color justify-start mb-3 txt-head>
                      Main page banners
                    </v-layout>
                    <div class="mb-7 cea-underline"></div>
                    <div class="mb-5 banner-box">
                      <div class="cea-color font-weight-bold mb-3">
                        Main page
                      </div>
                      <div v-if="homeBanner.desktop_img">
                        <v-img :src="http + homeBanner.desktop_img" class="banner-preview" contain></v-img>
                      </div>
                      <v-layout justify-end>
                        <v-flex mr-3 pt-3 shrink> Desktop size :</v-flex>
                        <v-flex xs7>
                          <v-file-input v-model="homeBanner.desktop_file"
                            label="ขนาดของไฟล์ไม่ควรเกิน 1 MB และขนาดรูป คือ 1900 x 792 px" show-size @change="
                              bannerImageAdded(
                                $event,
                                'homeBanner',
                                'desktop'
                              )
                              "></v-file-input>
                        </v-flex>
                      </v-layout>
                      <div v-if="homeBanner.mobile_img">
                        <v-img :src="http + homeBanner.mobile_img" class="banner-preview" contain></v-img>
                      </div>
                      <v-layout justify-end>
                        <v-flex mr-3 pt-3 shrink> Mobile size :</v-flex>
                        <v-flex xs7>
                          <v-file-input v-model="homeBanner.mobile_file"
                            label="ขนาดของไฟล์ไม่ควรเกิน 1 MB และขนาดรูป คือ 566 x 566 px" show-size @change="
                              bannerImageAdded(
                                $event,
                                'homeBanner',
                                'mobile'
                              )
                              "></v-file-input>
                        </v-flex>
                      </v-layout>
                    </div>
                  </v-flex>
                </v-layout>

                <!--Creative index page-->
                <v-layout column>
                  <v-flex mb-5 text-start>
                    <v-layout cea-color justify-start mb-3 txt-head>
                      Creative index page
                    </v-layout>
                    <div class="mb-7 cea-underline"></div>

                    <!--International page-->
                    <div class="mb-5 banner-box">
                      <div class="cea-color font-weight-bold mb-3">
                        International page
                      </div>
                      <div v-if="internationalBanner.desktop_img">
                        <v-img :src="http + internationalBanner.desktop_img" class="banner-preview" contain></v-img>
                      </div>
                      <v-layout justify-end>
                        <v-flex mr-3 pt-3 shrink> Desktop size :</v-flex>
                        <v-flex xs7>
                          <v-file-input v-model="internationalBanner.desktop_file"
                            label="ขนาดของไฟล์ไม่ควรเกิน 1 MB และขนาดรูป คือ 1900 x 792 px" show-size @change="
                              bannerImageAdded(
                                $event,
                                'internationalBanner',
                                'desktop'
                              )
                              "></v-file-input>
                        </v-flex>
                      </v-layout>
                      <div v-if="internationalBanner.mobile_img">
                        <v-img :src="http + internationalBanner.mobile_img" class="banner-preview" contain></v-img>
                      </div>
                      <v-layout justify-end>
                        <v-flex mr-3 pt-3 shrink> Mobile size :</v-flex>
                        <v-flex xs7>
                          <v-file-input v-model="internationalBanner.mobile_file"
                            label="ขนาดของไฟล์ไม่ควรเกิน 1 MB และขนาดรูป คือ 566 x 566 px" show-size @change="
                              bannerImageAdded(
                                $event,
                                'internationalBanner',
                                'mobile'
                              )
                              "></v-file-input>
                        </v-flex>
                      </v-layout>
                    </div>

                    <!--Country page-->
                    <div class="mb-5 banner-box">
                      <div class="cea-color font-weight-bold mb-3">
                        Country page
                      </div>
                      <div v-if="countryBanner.desktop_img">
                        <v-img :src="http + countryBanner.desktop_img" class="banner-preview" contain></v-img>
                      </div>
                      <v-layout justify-end>
                        <v-flex mr-3 pt-3 shrink> Desktop size :</v-flex>
                        <v-flex xs7>
                          <v-file-input v-model="countryBanner.desktop_file"
                            label="ขนาดของไฟล์ไม่ควรเกิน 1 MB และขนาดรูป คือ 1900 x 792 px" show-size @change="
                              bannerImageAdded(
                                $event,
                                'countryBanner',
                                'desktop'
                              )
                              "></v-file-input>
                        </v-flex>
                      </v-layout>
                      <div v-if="countryBanner.mobile_img">
                        <v-img :src="http + countryBanner.mobile_img" class="banner-preview" contain></v-img>
                      </div>
                      <v-layout justify-end>
                        <v-flex mr-3 pt-3 shrink> Mobile size :</v-flex>
                        <v-flex xs7>
                          <v-file-input v-model="countryBanner.mobile_file"
                            label="ขนาดของไฟล์ไม่ควรเกิน 1 MB และขนาดรูป คือ 566 x 566 px" show-size @change="
                              bannerImageAdded(
                                $event,
                                'countryBanner',
                                'mobile'
                              )
                              "></v-file-input>
                        </v-flex>
                      </v-layout>
                    </div>
                  </v-flex>
                </v-layout>

                <!--Other pages banner-->
                <v-layout column>
                  <v-flex mb-5 text-start>
                    <v-layout cea-color justify-start mb-3 txt-head>
                      Other pages banner
                    </v-layout>
                    <div class="mb-7 cea-underline"></div>
                    <!--Data & Statistics page-->
                    <div class="mb-5 banner-box">
                      <div class="cea-color font-weight-bold mb-3">
                        Data & Statistics page
                      </div>
                      <div v-if="dataAndStatsBanner.desktop_img">
                        <v-img :src="http + dataAndStatsBanner.desktop_img" class="banner-preview" contain></v-img>
                      </div>
                      <v-layout justify-end>
                        <v-flex mr-3 pt-3 shrink> Desktop size :</v-flex>
                        <v-flex xs7>
                          <v-file-input v-model="dataAndStatsBanner.desktop_file"
                            label="ขนาดของไฟล์ไม่ควรเกิน 1 MB และขนาดรูป คือ 1900 x 792 px" show-size @change="
                              bannerImageAdded(
                                $event,
                                'dataAndStatsBanner',
                                'desktop'
                              )
                              "></v-file-input>
                        </v-flex>
                      </v-layout>
                      <div v-if="dataAndStatsBanner.mobile_img">
                        <v-img :src="http + dataAndStatsBanner.mobile_img" class="banner-preview" contain></v-img>
                      </div>
                      <v-layout justify-end>
                        <v-flex mr-3 pt-3 shrink> Mobile size :</v-flex>
                        <v-flex xs7>
                          <v-file-input v-model="dataAndStatsBanner.mobile_file"
                            label="ขนาดของไฟล์ไม่ควรเกิน 1 MB และขนาดรูป คือ 566 x 566 px" show-size @change="
                              bannerImageAdded(
                                $event,
                                'dataAndStatsBanner',
                                'mobile'
                              )
                              "></v-file-input>
                        </v-flex>
                      </v-layout>
                    </div>
                    <!--Research & Report page-->
                    <div class="mb-5 banner-box">
                      <div class="cea-color font-weight-bold mb-3">
                        Research & Report page
                      </div>
                      <div v-if="researchReportBanner.desktop_img">
                        <v-img :src="http + researchReportBanner.desktop_img" class="banner-preview" contain></v-img>
                      </div>
                      <v-layout justify-end>
                        <v-flex mr-3 pt-3 shrink> Desktop size :</v-flex>
                        <v-flex xs7>
                          <v-file-input v-model="researchReportBanner.desktop_file"
                            label="ขนาดของไฟล์ไม่ควรเกิน 1 MB และขนาดรูป คือ 1900 x 792 px" show-size @change="
                              bannerImageAdded(
                                $event,
                                'researchReportBanner',
                                'desktop'
                              )
                              "></v-file-input>
                        </v-flex>
                      </v-layout>
                      <div v-if="researchReportBanner.mobile_img">
                        <v-img :src="http + researchReportBanner.mobile_img" class="banner-preview" contain></v-img>
                      </div>
                      <v-layout justify-end>
                        <v-flex mr-3 pt-3 shrink> Mobile size :</v-flex>
                        <v-flex xs7>
                          <v-file-input v-model="researchReportBanner.mobile_file"
                            label="ขนาดของไฟล์ไม่ควรเกิน 1 MB และขนาดรูป คือ 566 x 566 px" show-size @change="
                              bannerImageAdded(
                                $event,
                                'researchReportBanner',
                                'mobile'
                              )
                              "></v-file-input>
                        </v-flex>
                      </v-layout>
                    </div>

                    <!--About page-->
                    <div class="mb-5 banner-box">
                      <div class="cea-color font-weight-bold mb-3">
                        About page
                      </div>
                      <div v-if="aboutBanner.desktop_img">
                        <v-img :src="http + aboutBanner.desktop_img" class="banner-preview" contain></v-img>
                      </div>
                      <v-layout justify-end>
                        <v-flex mr-3 pt-3 shrink> Desktop size :</v-flex>
                        <v-flex xs7>
                          <v-file-input v-model="aboutBanner.desktop_file"
                            label="ขนาดของไฟล์ไม่ควรเกิน 1 MB และขนาดรูป คือ 1900 x 792 px" show-size @change="
                              bannerImageAdded($event, 'aboutBanner', 'desktop')
                              "></v-file-input>
                        </v-flex>
                      </v-layout>
                      <div v-if="aboutBanner.mobile_img">
                        <v-img :src="http + aboutBanner.mobile_img" class="banner-preview" contain></v-img>
                      </div>
                      <v-layout justify-end>
                        <v-flex mr-3 pt-3 shrink> Mobile size :</v-flex>
                        <v-flex xs7>
                          <v-file-input v-model="aboutBanner.mobile_file"
                            label="ขนาดของไฟล์ไม่ควรเกิน 1 MB และขนาดรูป คือ 566 x 566 px" show-size @change="
                              bannerImageAdded($event, 'aboutBanner', 'mobile')
                              "></v-file-input>
                        </v-flex>
                      </v-layout>
                    </div>

                    <!--Developer page-->
                    <div class="mb-5 banner-box">
                      <div class="cea-color font-weight-bold mb-3">
                        Developer page
                      </div>
                      <div v-if="developerBanner.desktop_img">
                        <v-img :src="http + developerBanner.desktop_img" class="banner-preview" contain></v-img>
                      </div>
                      <v-layout justify-end>
                        <v-flex mr-3 pt-3 shrink> Desktop size :</v-flex>
                        <v-flex xs7>
                          <v-file-input v-model="developerBanner.desktop_file"
                            label="ขนาดของไฟล์ไม่ควรเกิน 1 MB และขนาดรูป คือ 1900 x 792 px" show-size @change="
                              bannerImageAdded($event, 'developerBanner', 'desktop')
                              "></v-file-input>
                        </v-flex>
                      </v-layout>
                      <div v-if="developerBanner.mobile_img">
                        <v-img :src="http + developerBanner.mobile_img" class="banner-preview" contain></v-img>
                      </div>
                      <v-layout justify-end>
                        <v-flex mr-3 pt-3 shrink> Mobile size :</v-flex>
                        <v-flex xs7>
                          <v-file-input v-model="developerBanner.mobile_file"
                            label="ขนาดของไฟล์ไม่ควรเกิน 1 MB และขนาดรูป คือ 566 x 566 px" show-size @change="
                              bannerImageAdded($event, 'developerBanner', 'mobile')
                              "></v-file-input>
                        </v-flex>
                      </v-layout>
                    </div>
                  </v-flex>
                </v-layout>

                <v-layout justify-end>
                  <v-btn class="white--text mb-3" color="#FF4F23" large @click="saveBanner">บันทึก
                  </v-btn>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <!-- Power Bi management page -->
        <!--        <v-layout v-else-if="section === 'power-bi'" justify-center>-->
        <!--          <v-flex xs10>-->
        <!--            <v-layout justify-center>-->
        <!--              <v-layout column>-->
        <!--                <v-flex mb-5 text-start>-->
        <!--                  <v-layout justify-start cea-color txt-head mb-3>-->
        <!--                    <h1>Main page</h1>-->
        <!--                  </v-layout>-->

        <!--                  &lt;!&ndash; POWER BI International&ndash;&gt;-->
        <!--                  <div>-->
        <!--                    <v-layout justify-start cea-color txt-head mb-3 >-->
        <!--                      International-->
        <!--                    </v-layout>-->
        <!--                    <div class="mb-7 cea-underline"></div>-->
        <!--                    <div class="mb-5 banner-box">-->
        <!--                      <div class="cea-color font-weight-bold mb-3">-->
        <!--                        International-->
        <!--                      </div>-->
        <!--                                      <v-layout column>-->
        <!--                                        <v-flex mb-5 text-start>-->
        <!--                                          <v-layout justify-end>-->
        <!--                                            <v-flex shrink pt-3 mr-3> Embedded URL: </v-flex>-->
        <!--                                            <v-flex xs7>-->
        <!--                                              <v-text-field-->
        <!--                                                solo-->
        <!--                                                flat-->
        <!--                                                v-model="powerBi['international-power-bi'].embed_url"-->
        <!--                                              ></v-text-field>-->
        <!--                                            </v-flex>-->
        <!--                                          </v-layout>-->
        <!--                                          <v-layout justify-end>-->
        <!--                                            <v-flex shrink pt-3 mr-3> Description : </v-flex>-->
        <!--                                            <v-flex xs7>-->
        <!--                                              <v-text-field-->
        <!--                                                solo-->
        <!--                                                flat-->
        <!--                                                v-model="-->
        <!--                                                  powerBi['international-power-bi'].description-->
        <!--                                                "-->
        <!--                                              ></v-text-field>-->
        <!--                                            </v-flex>-->
        <!--                                          </v-layout>-->
        <!--                                        </v-flex>-->
        <!--                                      </v-layout>-->
        <!--                    </div>-->
        <!--                    <div style="display: flex; justify-content: right">-->
        <!--                      <v-btn-->
        <!--                          color="#FF4F23"-->
        <!--                          class="white&#45;&#45;text mb-3"-->
        <!--                          @click="addMorePowerBI"-->
        <!--                      >-->
        <!--                        <v-icon>add</v-icon>-->
        <!--                      </v-btn>-->
        <!--                    </div>-->
        <!--                  </div>-->
        <!--                  &lt;!&ndash; POWER BI Country&ndash;&gt;-->
        <!--                  <div class="mt-10">-->
        <!--                    <v-layout justify-start cea-color txt-head mb-3 >-->
        <!--                      Country-->
        <!--                    </v-layout>-->
        <!--                    <div class="mb-7 cea-underline"></div>-->
        <!--                    <div class="mb-5 banner-box">-->
        <!--                      <div class="cea-color font-weight-bold mb-3">-->
        <!--                        Country-->
        <!--                      </div>-->
        <!--                      <v-layout column>-->
        <!--                        <v-flex mb-5 text-start>-->
        <!--                          <v-layout justify-end>-->
        <!--                            <v-flex shrink pt-3 mr-3> Embedded URL: </v-flex>-->
        <!--                            <v-flex xs7>-->
        <!--                              <v-text-field-->
        <!--                                  solo-->
        <!--                                  flat-->
        <!--                                  v-model="powerBi['country-power-bi'].embed_url"-->
        <!--                              ></v-text-field>-->
        <!--                            </v-flex>-->
        <!--                          </v-layout>-->
        <!--                          <v-layout justify-end>-->
        <!--                            <v-flex shrink pt-3 mr-3> Description : </v-flex>-->
        <!--                            <v-flex xs7>-->
        <!--                              <v-text-field-->
        <!--                                  solo-->
        <!--                                  flat-->
        <!--                                  v-model="powerBi['country-power-bi'].description"-->
        <!--                              ></v-text-field>-->
        <!--                            </v-flex>-->
        <!--                          </v-layout>-->
        <!--                        </v-flex>-->
        <!--                      </v-layout>-->
        <!--                    </div>-->
        <!--                  </div>-->
        <!--                </v-flex>-->
        <!--              </v-layout>-->
        <!--&lt;!&ndash;              <v-flex xs10>&ndash;&gt;-->
        <!--&lt;!&ndash;                <v-layout justify-start cea-color txt-head mb-3>&ndash;&gt;-->
        <!--&lt;!&ndash;                  ทั่วโลก&ndash;&gt;-->
        <!--&lt;!&ndash;                </v-layout>&ndash;&gt;-->
        <!--&lt;!&ndash;                <div class="cea-underline mb-10"></div>&ndash;&gt;-->
        <!--&lt;!&ndash;                <v-layout column>&ndash;&gt;-->
        <!--&lt;!&ndash;                  <v-flex mb-5 text-start>&ndash;&gt;-->
        <!--&lt;!&ndash;                    <v-layout justify-end>&ndash;&gt;-->
        <!--&lt;!&ndash;                      <v-flex shrink pt-3 mr-3> Embedded URL: </v-flex>&ndash;&gt;-->
        <!--&lt;!&ndash;                      <v-flex xs7>&ndash;&gt;-->
        <!--&lt;!&ndash;                        <v-text-field&ndash;&gt;-->
        <!--&lt;!&ndash;                          solo&ndash;&gt;-->
        <!--&lt;!&ndash;                          flat&ndash;&gt;-->
        <!--&lt;!&ndash;                          v-model="powerBi['international-power-bi'].embed_url"&ndash;&gt;-->
        <!--&lt;!&ndash;                        ></v-text-field>&ndash;&gt;-->
        <!--&lt;!&ndash;                      </v-flex>&ndash;&gt;-->
        <!--&lt;!&ndash;                    </v-layout>&ndash;&gt;-->

        <!--&lt;!&ndash;                    <v-layout justify-end>&ndash;&gt;-->
        <!--&lt;!&ndash;                      <v-flex shrink pt-3 mr-3> Description : </v-flex>&ndash;&gt;-->
        <!--&lt;!&ndash;                      <v-flex xs7>&ndash;&gt;-->
        <!--&lt;!&ndash;                        <v-text-field&ndash;&gt;-->
        <!--&lt;!&ndash;                          solo&ndash;&gt;-->
        <!--&lt;!&ndash;                          flat&ndash;&gt;-->
        <!--&lt;!&ndash;                          v-model="&ndash;&gt;-->
        <!--&lt;!&ndash;                            powerBi['international-power-bi'].description&ndash;&gt;-->
        <!--&lt;!&ndash;                          "&ndash;&gt;-->
        <!--&lt;!&ndash;                        ></v-text-field>&ndash;&gt;-->
        <!--&lt;!&ndash;                      </v-flex>&ndash;&gt;-->
        <!--&lt;!&ndash;                    </v-layout>&ndash;&gt;-->
        <!--&lt;!&ndash;                  </v-flex>&ndash;&gt;-->
        <!--&lt;!&ndash;                </v-layout>&ndash;&gt;-->

        <!--&lt;!&ndash;                <v-layout justify-end>&ndash;&gt;-->
        <!--&lt;!&ndash;                  <v-btn&ndash;&gt;-->
        <!--&lt;!&ndash;                    large&ndash;&gt;-->
        <!--&lt;!&ndash;                    color="#FF4F23"&ndash;&gt;-->
        <!--&lt;!&ndash;                    class="white&#45;&#45;text mb-3"&ndash;&gt;-->
        <!--&lt;!&ndash;                    @click="savePowerBi('international-power-bi')"&ndash;&gt;-->
        <!--&lt;!&ndash;                    >บันทึก</v-btn&ndash;&gt;-->
        <!--&lt;!&ndash;                  >&ndash;&gt;-->
        <!--&lt;!&ndash;                </v-layout>&ndash;&gt;-->

        <!--&lt;!&ndash;                <v-layout justify-start cea-color txt-head mb-3>&ndash;&gt;-->
        <!--&lt;!&ndash;                  ในประเทศ&ndash;&gt;-->
        <!--&lt;!&ndash;                </v-layout>&ndash;&gt;-->
        <!--&lt;!&ndash;                <div class="cea-underline mb-10"></div>&ndash;&gt;-->

        <!--&lt;!&ndash;                <v-layout column>&ndash;&gt;-->
        <!--&lt;!&ndash;                  <v-flex mb-5 text-start>&ndash;&gt;-->
        <!--&lt;!&ndash;                    <v-layout justify-end>&ndash;&gt;-->
        <!--&lt;!&ndash;                      <v-flex shrink pt-3 mr-3> Embedded URL: </v-flex>&ndash;&gt;-->
        <!--&lt;!&ndash;                      <v-flex xs7>&ndash;&gt;-->
        <!--&lt;!&ndash;                        <v-text-field&ndash;&gt;-->
        <!--&lt;!&ndash;                          solo&ndash;&gt;-->
        <!--&lt;!&ndash;                          flat&ndash;&gt;-->
        <!--&lt;!&ndash;                          v-model="powerBi['country-power-bi'].embed_url"&ndash;&gt;-->
        <!--&lt;!&ndash;                        ></v-text-field>&ndash;&gt;-->
        <!--&lt;!&ndash;                      </v-flex>&ndash;&gt;-->
        <!--&lt;!&ndash;                    </v-layout>&ndash;&gt;-->

        <!--&lt;!&ndash;                    <v-layout justify-end>&ndash;&gt;-->
        <!--&lt;!&ndash;                      <v-flex shrink pt-3 mr-3> Description : </v-flex>&ndash;&gt;-->
        <!--&lt;!&ndash;                      <v-flex xs7>&ndash;&gt;-->
        <!--&lt;!&ndash;                        <v-text-field&ndash;&gt;-->
        <!--&lt;!&ndash;                          solo&ndash;&gt;-->
        <!--&lt;!&ndash;                          flat&ndash;&gt;-->
        <!--&lt;!&ndash;                          v-model="powerBi['country-power-bi'].description"&ndash;&gt;-->
        <!--&lt;!&ndash;                        ></v-text-field>&ndash;&gt;-->
        <!--&lt;!&ndash;                      </v-flex>&ndash;&gt;-->
        <!--&lt;!&ndash;                    </v-layout>&ndash;&gt;-->
        <!--&lt;!&ndash;                  </v-flex>&ndash;&gt;-->
        <!--&lt;!&ndash;                </v-layout>&ndash;&gt;-->

        <!--&lt;!&ndash;                <v-layout justify-end>&ndash;&gt;-->
        <!--&lt;!&ndash;                  <v-btn&ndash;&gt;-->
        <!--&lt;!&ndash;                    large&ndash;&gt;-->
        <!--&lt;!&ndash;                    color="#FF4F23"&ndash;&gt;-->
        <!--&lt;!&ndash;                    class="white&#45;&#45;text mb-3"&ndash;&gt;-->
        <!--&lt;!&ndash;                    @click="savePowerBi('country-power-bi')"&ndash;&gt;-->
        <!--&lt;!&ndash;                    >บันทึก</v-btn&ndash;&gt;-->
        <!--&lt;!&ndash;                  >&ndash;&gt;-->
        <!--&lt;!&ndash;                </v-layout>&ndash;&gt;-->
        <!--&lt;!&ndash;              </v-flex>&ndash;&gt;-->
        <!--            </v-layout>-->
        <!--          </v-flex>-->
        <!--        </v-layout>-->

        <!-- Footer management page -->
        <v-layout v-else-if="section === 'footer'" justify-center>
          <v-flex xs12>
            <v-layout justify-center>
              <v-flex xs10>
                <v-layout column>
                  <v-flex mb-5 text-start>
                    <v-layout justify-end>
                      <v-flex mr-3 pt-3 shrink>
                        โลโก้สำนักนายกรัฐมนตรี :
                      </v-flex>
                      <v-flex xs7>
                        <v-text-field v-model="footer.logo_opm_url" flat placeholder="ลิ้งค์ไปที่" solo></v-text-field>
                      </v-flex>
                    </v-layout>

                    <v-layout justify-end>
                      <v-flex mr-3 pt-3 shrink> โลโก้ CEA :</v-flex>
                      <v-flex xs7>
                        <v-text-field v-model="footer.logo_site_url" flat placeholder="ลิ้งค์ไปที่" solo></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex mb-5 text-start>
                    <v-layout justify-end>
                      <v-flex mr-3 pt-3 shrink>
                        Creative Economy Review :
                      </v-flex>
                      <v-flex xs7>
                        <v-text-field v-model="footer.creative_economy_review_url" flat placeholder="ลิ้งค์ไปที่"
                          solo></v-text-field>
                      </v-flex>
                    </v-layout>

                    <v-layout justify-end>
                      <v-flex mr-3 pt-3 shrink> Data and Statistics :</v-flex>
                      <v-flex xs7>
                        <v-text-field v-model="footer.data_and_statistics_url" flat placeholder="ลิ้งค์ไปที่"
                          solo></v-text-field>
                      </v-flex>
                    </v-layout>

                    <v-layout justify-end>
                      <v-flex mr-3 pt-3 shrink> Research and report :</v-flex>
                      <v-flex xs7>
                        <v-text-field v-model="footer.research_and_report_url" flat placeholder="ลิ้งค์ไปที่"
                          solo></v-text-field>
                      </v-flex>
                    </v-layout>

                    <v-layout justify-end>
                      <v-flex mr-3 pt-3 shrink> Creativity index :</v-flex>
                      <v-flex xs7>
                        <v-text-field v-model="footer.c_index_url" flat placeholder="ลิ้งค์ไปที่" solo></v-text-field>
                      </v-flex>
                    </v-layout>

                    <v-layout justify-end>
                      <v-flex mr-3 pt-3 shrink> About :</v-flex>
                      <v-flex xs7>
                        <v-text-field v-model="footer.about_url" flat placeholder="ลิ้งค์ไปที่" solo></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>

                <v-layout cea-color justify-start mb-3 txt-head>
                  ข้อมูลติดต่อเรา
                </v-layout>
                <div class="cea-underline mb-10"></div>

                <v-layout column>
                  <v-flex mb-5 text-start>
                    <v-layout justify-end>
                      <v-flex mr-3 pt-3 shrink> ที่อยู่ (TH):</v-flex>
                      <v-flex xs7>
                        <v-textarea v-model="footer.address_th" auto-grow flat solo></v-textarea>
                      </v-flex>
                    </v-layout>

                    <v-layout justify-end>
                      <v-flex mr-3 pt-3 shrink> ที่อยู่ (EN):</v-flex>
                      <v-flex xs7>
                        <v-textarea v-model="footer.address_en" auto-grow flat solo></v-textarea>
                      </v-flex>
                    </v-layout>

                    <v-layout justify-end>
                      <v-flex mr-3 pt-3 shrink> โทรศัพท์ :</v-flex>
                      <v-flex xs7>
                        <v-text-field v-model="footer.tel" flat solo></v-text-field>
                      </v-flex>
                    </v-layout>

                    <v-layout justify-end>
                      <v-flex mr-3 pt-3 shrink> โทรสาร :</v-flex>
                      <v-flex xs7>
                        <v-text-field v-model="footer.fax" flat solo></v-text-field>
                      </v-flex>
                    </v-layout>

                    <v-layout justify-end>
                      <v-flex mr-3 pt-3 shrink> อีเมล :</v-flex>
                      <v-flex xs7>
                        <v-text-field v-model="footer.email" flat solo></v-text-field>
                      </v-flex>
                    </v-layout>

                    <v-layout justify-end>
                      <v-flex mr-3 pt-3 shrink>
                        Facebook ชื่อที่แสดง (TH) :
                      </v-flex>
                      <v-flex xs7>
                        <v-text-field v-model="footer.fb_title_th" flat solo></v-text-field>
                      </v-flex>
                    </v-layout>

                    <v-layout justify-end>
                      <v-flex mr-3 pt-3 shrink>
                        Facebook ชื่อที่แสดง (EN) :
                      </v-flex>
                      <v-flex xs7>
                        <v-text-field v-model="footer.fb_title_en" flat solo></v-text-field>
                      </v-flex>
                    </v-layout>

                    <v-layout justify-end>
                      <v-flex mr-3 pt-3 shrink> Facebook ลิ้ง :</v-flex>
                      <v-flex xs7>
                        <v-text-field v-model="footer.fb_url" flat solo></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>

                <v-layout justify-end>
                  <v-btn class="white--text mb-3" color="#FF4F23" large @click="saveFooter">บันทึก
                  </v-btn>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <!-- Number box management page -->
        <v-layout v-else-if="section === 'number-box'" justify-center>
          <v-flex xs12>
            <v-layout justify-center>
              <v-flex xs10>
                <v-layout justify-end>
                  <v-flex mr-3 pt-3 shrink>
                    กล่องแสดงข้อมูลกล่องแรกผูกกับข้อมูล :
                  </v-flex>
                  <v-flex xs7>
                    <v-select v-model="numberBox1" :items="allTopicSelect" flat solo></v-select>
                  </v-flex>
                </v-layout>

                <v-layout justify-end>
                  <v-flex mr-3 pt-3 shrink>
                    กล่องแสดงข้อมูลกล่องที่สองผูกกับข้อมูล :
                  </v-flex>
                  <v-flex xs7>
                    <v-select v-model="numberBox2" :items="allTopicSelect" flat solo></v-select>
                  </v-flex>
                </v-layout>

                <v-layout justify-end>
                  <v-flex mr-3 pt-3 shrink>
                    กล่องแสดงข้อมูลกล่องที่สามผูกกับข้อมูล :
                  </v-flex>
                  <v-flex xs7>
                    <v-select v-model="numberBox3" :items="allTopicSelect" flat solo></v-select>
                  </v-flex>
                </v-layout>

                <v-layout justify-end>
                  <v-btn class="white--text mb-3" color="#FF4F23" large @click="saveNumberBox">บันทึก
                  </v-btn>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-content>
</template>

<script>
import Header from "../components/Header";
import InputForm from "../components/InputForm";
import { mapActions, mapState } from "vuex";
import Service from "../services";
import Loading from "vue-loading-overlay";
import { domain } from "../services/Constants";
import axios from "axios";
import Swal from "sweetalert2";
import draggable from 'vuedraggable'

export default {
  name: "data-manager",
  props: ["section"],
  components: {
    Header,
    InputForm,
    Loading,
    draggable
  },
  data: () => ({
    chk_valid: 0,
    enabled: true,
    list: [],
    dragging: false,
    dataParam: {},
    pageVisible: 8,
    http: domain,
    keywordTopic: "",
    keywordImport: "",
    yearImport: "All",
    yearList: ["All"],
    importedLoaded: false,
    topicLoaded: false,
    unitLoaded: false,
    tagLoaded: false,
    mainMenuLoaded: false,
    paginationImported: {
      current: 1,
      total: 1,
      itemPerPage: 10,
    },
    paginationTopic: {
      current: 1,
      total: 1,
      itemPerPage: 10,
    },
    paginationUnit: {
      current: 1,
      total: 1,
      itemPerPage: 10,
    },
    paginationTag: {
      current: 1,
      total: 1,
      itemPerPage: 10,
    },
    paginationMainMenu: {
      current: 1,
      total: 1,
      itemPerPage: 10,
    },
    sectionLoaded: true,
    numberBox1: null,
    numberBox2: null,
    numberBox3: null,
    overviewBanner: [
      {
        url: '',
        desktop_img: undefined,
        mobile_img: undefined,
        desktop_file: undefined,
        mobile_file: undefined,
      },
    ],
    internationalBanner: {},
    countryBanner: {},
    dataAndStatsBanner: {},
    researchReportBanner: {},
    aboutBanner: {},
    developerBanner: {},
    homeBanner: {},
    // powerBiData: {
    //   url: "",
    //   description: "",
    // },
  }),
  created() {
    this.dataParam.token = this.userData.token;
    let diff = new Date().getFullYear() + 543 - 2553;
    for (let i = 0; i <= diff; i++) {
      this.yearList.push(2553 + i);
    }

    this.onGetAllUnitPaginate(this.dataParam).then(() => {
      this.onUnitPageChange();
    });
    this.onGetAllTagPaginate(this.dataParam).then(() => {
      this.onTagPageChange();
    });
    this.onGetAllTopicPaginate(this.dataParam).then(() => {
      this.onTopicPageChange();
    });
    this.onGetAllImportedPaginate(this.dataParam).then(() => {
      this.onImportedPageChange();
    });
    this.onGetAllMainMenu(this.dataParam).then(() => {
      this.onMainMenuPageChang();
    });
    this.onGetAllTopic();
    this.populateNumberBox().then(() => {
      this.numberBox1 = this.numberBox[0].topic_id;
      this.numberBox2 = this.numberBox[1].topic_id;
      this.numberBox3 = this.numberBox[2].topic_id;
    });
    this.populateFooter();
    this.onGetAllPowerBi();
    this.getAllBannerData();

  },
  watch: {
    // re-render pagination
    section: function () {
      this.importedLoaded = false;
      this.topicLoaded = false;
      this.unitLoaded = false;
      this.tagLoaded = false;
      this.mainMenuLoaded = false;
      setTimeout(() => {
        this.importedLoaded = true;
        this.topicLoaded = true;
        this.unitLoaded = true;
        this.tagLoaded = true;
        this.mainMenuLoaded = true;
      }, 1);
    },
  },
  computed: {
    ...mapState({
      userData: (state) => state.auth.userData,
      unitList: (state) => state.data.allUnitPaginate,
      tagList: (state) => state.data.allTagPaginate,
      topicList: (state) => state.data.allTopicPaginate,
      importedList: (state) => state.data.allImportedPaginate,
      footer: (state) => state.site.footer,
      powerBi: (state) => state.powerBi,
      mainMenuList: (state) => state.data.mainMenuPaginate,
      allTopicSelect: (state) => {
        return [
          ...state.data.allTopic.map((topic) => ({
            text: topic.name_th,
            value: topic.id,
          })),
        ];
      },
      numberBox: (state) => state.data.numberBox,
    }),
    draggingInfo() {
      return this.dragging ? "under drag" : "";
    }
  },
  methods: {
    ...mapActions("data", [
      "onGetAllUnitPaginate",
      "onGetAllTagPaginate",
      "onGetAllTopic",
      "onGetAllTopicPaginate",
      "onGetAllImportedPaginate",
      "populateNumberBox",
      "updateNumberBox",
      "onGetAllMainMenu"
    ]),
    ...mapActions("site", ["populateFooter", "updateFooter"]),
    ...mapActions("powerBi", ["onGetAllPowerBi", "onUpdatePowerBi"]),
    onUnitPageChange(page) {
      let data = { page: page, token: this.userData.token };

      this.paginationUnit.total = Math.ceil(
        this.unitList.total / this.paginationUnit.itemPerPage
      );

      Service.data.getAllUnitPaginate(data).then((res) => {
        this.paginationUnit.current = res.current_page;
        this.unitList.data = res.data;
        this.unitLoaded = true;
      });
    },
    onTagPageChange(page) {
      let data = { page: page, token: this.userData.token };

      this.paginationTag.total = Math.ceil(
        this.tagList.total / this.paginationTag.itemPerPage
      );

      Service.data.getAllTagPaginate(data).then((res) => {
        this.paginationTag.current = res.current_page;
        this.tagList.data = res.data;
        this.tagLoaded = true;
      });
    },
    onMainMenuPageChang(page) {
      let data = { page: page, token: this.userData.token };

      this.paginationMainMenu.total = Math.ceil(
        this.mainMenuList.total / this.paginationMainMenu.itemPerPage
      );

      Service.data.index(data).then((res) => {
        this.paginationMainMenu.current = res.current_page;
        this.mainMenuList.data = res.data;
        this.mainMenuLoaded = true;
      });
    },
    onTopicPageChange(page) {
      let data = { page: page, token: this.userData.token };

      this.paginationTopic.total = Math.ceil(
        this.topicList.total / this.paginationTopic.itemPerPage
      );

      Service.data.getAllTopicPaginate(data).then((res) => {
        this.paginationTopic.current = res.current_page;
        this.topicList.data = res.data;
        this.topicLoaded = true;
      });
    },

    onImportedPageChange(page) {
      let data = { page: page, token: this.userData.token };

      this.paginationImported.total = Math.ceil(
        this.importedList.total / this.paginationImported.itemPerPage
      );

      Service.data
        .getAllImportedPaginate(data)
        .then((res) => {
          this.paginationImported.current = res.current_page;
          this.importedList.data = res.data;
          this.importedLoaded = true;
        })
        .then(() => {
          this.sectionLoaded = false; // set finish loading
        });
    },
    openFile(file_path) {
      // TODO: Preview excel
      window.open(this.http + "/" + file_path);
    },
    getAllBannerData() {
      this.$store.dispatch("banner/onGetAllBanners").then((banners) => {
        for (const banner of banners) {
          switch (banner.page) {
            case "HomeMain":
              // eslint-disable-next-line no-console
              // console.log(banners)
              // for (let x = 0; x < banner.desktop_img.length; x++) {
              //   if (!this.overviewBanner[x]) this.overviewBanner.push({});
              //   this.overviewBanner[x].desktop_img = banner.desktop_img[x];
              //   this.overviewBanner[x].mobile_img = banner.mobile_img[x];
              //   if (banner.url) {
              //     this.overviewBanner[x].url = banner.url[x];
              //   } else {
              //     this.overviewBanner[x].url = null
              //   }
              // }
              this.homeBanner = banner;
              break;
            case "International":
              this.internationalBanner = banner;
              break;
            case "Country":
              this.countryBanner = banner;
              break;
            case "DataAndStats":
              this.dataAndStatsBanner = banner;
              break;
            case "ResearchAndReport":
              this.researchReportBanner = banner;
              break;
            case "About":
              this.aboutBanner = banner;
              break;
            case "Developer":
              this.developerBanner = banner;
              break;
          }
        }
      });
    },
    async saveFooter() {
      await this.updateFooter();
      Swal.fire({
        icon: 'success',
        title: 'เรียบร้อย!',
        text: 'แก้ไขข้อมูลสำเร็จ',
      })
      // alert("แก้ไขข้อมูลสำเร็จ");
    },
    async savePowerBi(name) {
      const res = await this.onUpdatePowerBi(name);
      alert(res);
    },
    async saveNumberBox() {
      if (
        this.numberBox1 === this.numberBox2 ||
        this.numberBox1 === this.numberBox3 ||
        this.numberBox2 === this.numberBox3
      ) {
        Swal.fire({
          icon: 'warning',
          text: 'ห้ามเลือกข้อมูลซ้ำ',
        })
        // alert("ห้ามเลือกข้อมูลซ้ำ");
        return;
      }

      try {
        const numberBoxes = await Promise.all([
          this.updateNumberBox({
            id: 1,
            topic_id: this.numberBox1,
          }),
          this.updateNumberBox({
            id: 2,
            topic_id: this.numberBox2,
          }),
          this.updateNumberBox({
            id: 3,
            topic_id: this.numberBox3,
          }),

        ]);
        // eslint-disable-next-line no-console
        // console.log(numberBoxes)

        // alert("แก้ไขข้อมูลสำเร็จ");
        Swal.fire({
          icon: 'success',
          title: 'เรียบร้อย!',
          text: 'แก้ไขข้อมูลสำเร็จ',
        })
      } catch (err) {
        Swal.fire({
          icon: 'error',
          title: 'ผิดพลาด!',
          text: err.message,
        })
        // alert(err.message);
      }
    },
    addMoreBanner() {
      if (this.overviewBanner.length < 5) {
        this.overviewBanner.push({
          desktop_img: undefined,
          mobile_img: undefined,
          desktop_file: undefined,
          mobile_file: undefined,
        });
      }
    },
    removeBannerIndex(index) {
      if (this.overviewBanner.length > 1) {
        this.overviewBanner.splice(index, 1);
      } else {
        Swal.fire({
          icon: 'warning',
          text: 'ควรมีอย่างน้อย 1 แบนเนอร์',
        })
        // alert("ควรมีอย่างน้อย 1 แบนเนอร์");
      }
    },
    async saveBanner() {
      this.sectionLoaded = true;
      // let overviewDesktop = [];
      // let overviewMobile = [];
      // let overviewUrl = [];
      // for (const item of this.overviewBanner) {
      //   if (item.desktop_img && item.mobile_img) {
      //     overviewDesktop.push(item.desktop_img);
      //     overviewMobile.push(item.mobile_img);
      //     overviewUrl.push(item.url != null ? item.url : '');
      //   }
      // }
      await Promise.all([
        this.$store.dispatch("banner/onUpdateBanners", {
          page: "HomeMain",
          desktop_img: this.homeBanner.desktop_img,
          mobile_img: this.homeBanner.mobile_img,
          is_slides: false,
        }),
        this.$store.dispatch("banner/onUpdateBanners", {
          page: "International",
          desktop_img: this.internationalBanner.desktop_img,
          mobile_img: this.internationalBanner.mobile_img,
          is_slides: false,
        }),
        this.$store.dispatch("banner/onUpdateBanners", {
          page: "Country",
          desktop_img: this.countryBanner.desktop_img,
          mobile_img: this.countryBanner.mobile_img,
          is_slides: false,
        }),
        this.$store.dispatch("banner/onUpdateBanners", {
          page: "DataAndStats",
          desktop_img: this.dataAndStatsBanner.desktop_img,
          mobile_img: this.dataAndStatsBanner.mobile_img,
          is_slides: false,
        }),
        this.$store.dispatch("banner/onUpdateBanners", {
          page: "ResearchAndReport",
          desktop_img: this.researchReportBanner.desktop_img,
          mobile_img: this.researchReportBanner.mobile_img,
          is_slides: false,
        }),
        this.$store.dispatch("banner/onUpdateBanners", {
          page: "About",
          desktop_img: this.aboutBanner.desktop_img,
          mobile_img: this.aboutBanner.mobile_img,
          is_slides: false,
        }),
        this.$store.dispatch("banner/onUpdateBanners", {
          page: "Developer",
          desktop_img: this.developerBanner.desktop_img,
          mobile_img: this.developerBanner.mobile_img,
          is_slides: false,
        }),
      ]);
      this.sectionLoaded = false;
      // Swal.fire({
      //   icon: 'success',
      //   title: 'แก้ไขข้อมูลสำเร็จ',
      // })
      if (this.bannerValidate()) {
        Swal.fire({
          icon: 'success',
          title: 'แก้ไขข้อมูลสำเร็จ',
        })
      } else {
        Swal.fire({
          icon: 'warning',
          text: 'กรุณาเพิ่มรูป Banner ให้ครบ',
        })
      }
    },
    bannerValidate() {
      if (
        this.internationalBanner.desktop_img &&
        this.internationalBanner.mobile_img &&
        this.countryBanner.desktop_img &&
        this.countryBanner.mobile_img &&
        this.dataAndStatsBanner.desktop_img &&
        this.dataAndStatsBanner.mobile_img &&
        this.researchReportBanner.desktop_img &&
        this.researchReportBanner.mobile_img &&
        this.aboutBanner.desktop_img &&
        this.aboutBanner.mobile_img &&
        this.developerBanner.desktop_img &&
        this.developerBanner.mobile_img && 
        this.homeBanner.desktop_img &&
        this.homeBanner.mobile_img
      ) {
        return true;
      } else {
        return false;
      }
    },
    bannerImageAdded(file, name, size, index = undefined) {
      if (file) {
        this.sectionLoaded = true;
        let formData = new FormData();
        formData.append("image", file);
        axios({
          url: domain + "/api/banners/add",
          method: "POST",
          data: formData,
          headers: { Authorization: `Bearer ${this.userData.token}` },
        })
          .then((result) => {
            let path = "/" + result.data; // Get url from response
            if (index === undefined) {
              this[name][`${size}_img`] = path;
            } else {
              this[name][index][`${size}_img`] = path;
            }
            this.$forceUpdate();
            this.sectionLoaded = false;
          })
          .catch((err) => {
            // eslint-disable-next-line no-console
            console.log(err);
            this.sectionLoaded = false;
          });
      }
    },
    searchTopic() {
      let param = { keyword: this.keywordTopic, token: this.userData.token };
      this.sectionLoaded = true;

      if (param.keyword === "") {
        this.onGetAllTopicPaginate(this.dataParam)
          .then(() => {
            this.onTopicPageChange();
          })
          .then(() => {
            this.sectionLoaded = false;
          });
        return;
      }

      Service.data
        .searchTopic(param)
        .then((res) => {
          this.topicList.data = res;
          this.topicLoaded = false;
        })
        .then(() => {
          this.sectionLoaded = false; // set finish loading
        });
    },
    searchImport() {
      let param = {
        keyword: this.keywordImport,
        year: this.yearImport,
        token: this.userData.token,
      };
      this.sectionLoaded = true;

      if (param.keyword === "" && param.year === "All") {
        this.onGetAllImportedPaginate(this.dataParam)
          .then(() => {
            this.onImportedPageChange();
          })
          .then(() => {
            this.sectionLoaded = false;
          });
        return;
      }

      Service.data
        .searchImport(param)
        .then((res) => {
          this.importedList.data = res;
          this.importedLoaded = false;
        })
        .then(() => {
          this.sectionLoaded = false; // set finish loading
        });
    },
    checkMove: function (e) {
      window.console.log("Future index: " + e.draggedContext.futureIndex);
    }
  },
};
</script>

<style scoped>
.theme--light.v-data-table thead tr td:not(:last-child),
.theme--light.v-data-table tbody tr td:not(:last-child) {
  border-right: solid 1px #d7d7d7 !important;
}

.banner-box {
  position: relative;
  background: rgba(0, 0, 0, 0.05);
  padding: 8px 12px;
  border-radius: 6px;
}

.banner-preview {
  max-height: 100px;
  max-width: 300px;
}

.ghost {
  opacity: 0.5;
  background: #f5a08b;
}
</style>
